<mat-dialog-content class="!p-0">
  <header class="flex justify-between">
    <h2 class="text-2xl font-medium">Out of office</h2>
    <!-- Close dialog button -->
    <button mat-icon-button type="button" (click)="onCancelClick()" class="button-close ml-auto">
      <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
      <span class="sr-only" i18n>Close</span>
    </button>
  </header>
  <div class="flex flex-row box-border place-content-center items-center">
    <div class="flex-1 box-border">
      <form [formGroup]="vacationForm" class="mb-5">
        <!-- Title -->
        <div class="field-control flex flex-col box-border content-center justify-start items-baseline">
          <span class="field-label mr-1 box-border" i18n>Title</span>
          <mat-form-field appearance="outline" class="box-border max-w-[40%] w-full">
            <input matInput placeholder="Title" i18n-placeholder formControlName="title" />
            <mat-error *ngIf="vacationForm.controls['title'].errors?.['required']" i18n>Title is required</mat-error>
            <mat-error *ngIf="vacationForm.controls['title'].errors?.['minlength']" i18n>Minimum 2 characters</mat-error>
            <mat-error *ngIf="vacationForm.controls['title'].errors?.['invalidName']" i18n>Invalid character in title</mat-error>
          </mat-form-field>
        </div>
        <!-- Start date and time -->
        <div class="start-date-time flex flex-row gap-4">
          <!-- Start date -->
          <div class="field-control flex flex-col box-border content-center justify-start items-baseline">
            <span class="field-label mr-1 box-border" i18n>Start date<sup class="top-[-4px]">*</sup></span>
            <mat-form-field appearance="outline" class="box-border w-full">
              <input matInput [matDatepicker]="pickerStartDate" placeholder="DD/MM/YYYY" i18n-placeholder formControlName="from" readonly [min]="minStartDate" (dateChange)="startDateChange($event)" />
              <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
              <mat-datepicker time="true" #pickerStartDate></mat-datepicker>
              <mat-error *ngIf="vacationForm.controls['from'].errors?.['required']" i18n>Date is required</mat-error>
            </mat-form-field>
          </div>
          <!-- Start time -->
          <div class="field-control flex flex-col box-border content-center justify-start">
            <span class="field-label mr-1 box-border" i18n>Start time</span>
            <mat-form-field appearance="outline" class="box-border w-full">
              <mat-select formControlName="startTime">
                <mat-option *ngFor="let segment of timeSegments" [value]="segment">
                  {{ segment }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!-- End date and time -->
        <div class="end-date-time flex flex-row gap-4">
          <!-- End date -->
          <div class="field-control flex flex-col box-border content-center justify-start items-baseline">
            <span class="field-label mr-1 box-border" i18n>End date<sup class="top-[-4px]">*</sup> </span>
            <mat-form-field appearance="outline" class="box-border w-full">
              <input matInput [matDatepicker]="pickerDeadline" placeholder="DD/MM/YYYY" i18n-placeholder formControlName="to" readonly [min]="minEndDate" (dateChange)="endDateChange($event)" />
              <mat-datepicker-toggle matSuffix [for]="pickerDeadline"></mat-datepicker-toggle>
              <mat-datepicker time="true" #pickerDeadline></mat-datepicker>
              <mat-error *ngIf="vacationForm.controls['from'].errors?.['required']" i18n>Date is required</mat-error>
            </mat-form-field>
          </div>
          <!-- End time -->
          <div class="field-control flex flex-col box-border content-center justify-start items-baseline">
            <span class="field-label mr-1 box-border" i18n>End time</span>
            <mat-form-field appearance="outline" class="box-border w-full">
              <mat-select formControlName="endTime">
                <mat-option *ngFor="let segment of timeSegments" [value]="segment">
                  {{ segment }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!-- Out of office message -->
        <div class="field-control flex flex-col box-border content-center justify-start items-baseline relative">
          <span class="field-label mr-1 box-border absolute top-[-6px]" i18n>Out of office message</span>
          <sp-editor formControlName="message" [placeholder]="'Test placeholder'" [maxLength]="5000" class="w-full"></sp-editor>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="!p-0">
  <div class="flex flex-row box-border content-center justify-between items-center w-full gap-4">
    <button type="button" class="button-secondary" mat-flat-button mat-dialog-close (click)="onCancelClick()" i18n>Cancel</button>
    <button type="button" [disabled]="vacationForm.invalid" class="save-button button-primary" mat-flat-button (click)="saveData()">
      <mat-icon *ngIf="!isNew">save</mat-icon>
      <ng-container i18n>{{ isNew ? 'Create' : 'Save' }}</ng-container>
    </button>
  </div>
</mat-dialog-actions>
